import { Image } from '@mantine/core';
import { ONLINE_CINEMAS_TITLE } from '@/modules/tariff/shared/constants';
import { useGetHomeInternetServicesQuery } from '@/store/api/service-home-internet/service-home-internet.api';
import { HOME_INTERNET_SERVICE_TYPE } from '@/store/api/service-home-internet/service-home-internet.type';
import styles from './online-cinemas.module.scss';

export const OnlineCinemasBlock = () => {
  const { data } = useGetHomeInternetServicesQuery({
    populate: '*',
    'filters[service_type][$eq]': HOME_INTERNET_SERVICE_TYPE.KINOMANIYA,
    sort: 'priority',
  });

  return (
    <div className={styles.container}>
      <div className={styles.title}>{ONLINE_CINEMAS_TITLE}</div>
      {data?.data?.map(({ attributes, id }) => (
        <div key={id} className={styles.item__wrapper}>
          {attributes?.background_image?.data?.attributes && (
            <Image
              src={attributes?.background_image?.data?.attributes?.url}
              alt={attributes?.localized_name}
              height='20px'
              h='20px'
              mah='20px'
              width='auto'
              fit='contain'
            />
          )}
          <span className={styles.item__description}>{attributes.promotion_description}</span>
        </div>
      ))}
    </div>
  );
};
